import { apiGet } from '../support/helpers/ApiConnection.Helper';
import CoverageTypeEntity from '../entities/CoverageType.Entity';

export default function getCoverageTypes(abortSignal: AbortSignal): Promise<Array<CoverageTypeEntity>> {   
    return apiGet<Array<CoverageTypeEntity>>('/coverage-types',abortSignal);
}
